// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b6945538","24":"d3da62b4","453":"5eeee009","970":"de06fcea"}[chunkId] + ".chunk.js";
};